import MobileMenu from "./components/MobileMenu";
/**
 * This is the main entry point of the Javascript.
 * It initializes the necessary components.
 */

import { setCookie, getCookie } from "./components/cookies";
import Links from "./components/Links";
import Sliders from "./components/Sliders";

document.addEventListener("DOMContentLoaded", () => {
	console.log("first run");

    MobileMenu();
    Links();
    Sliders();
});
